import { z as e } from "zod";
const r = e.enum(["common", "admin"]), i = r.enum, l = (n, a) => {
  const o = n.unwrap(), c = a.unwrap(), m = o.extend({ view: e.literal(i.common) }).readonly(), t = o.extend(c.shape).extend({ view: e.literal(i.admin) }).readonly(), d = e.discriminatedUnion("view", [m, t]).readonly();
  return { common: m, admin: t, union: d };
}, s = (n) => n.view === i.admin, p = (n) => {
  if (!s(n))
    throw new Error("Expected admin view");
};
export {
  i as API_VIEW,
  r as ApiViewKindSchema,
  p as assertAdminView,
  l as createViewSchemas,
  s as isAdminView
};
//# sourceMappingURL=acl-view.js.map
